<template>
  <div class="business">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div>
     
      <div class="mb-3">
        <span> <strong>Salary (₹)</strong></span>
        <span class="text-right-side"> <strong>₹ {{tdsBreakupList[tdsBreakupList.length -1].totalEarning}}</strong></span>
        <!-- {{salaryTotal}} -->
      </div>

      <!-- Table -->
        <div class="datatable-outer-container">
            <div class="datatable-main">
                <table class="datatable">
                  <thead>
                    <tr class="header-row">
                      <th v-for="(column, index) in columnsList" :key="index" class="table-head"> 
                        {{column}} 
                      </th>
                    </tr>
                  </thead>
                  <tr class="record-row" v-for="(data, index) in dataList" :key="index">
                    <td class="row-item" v-for="(column, index2) in columnsList" :key="index2">
                      {{ data[column] ? data[column] : 0 }}
                    </td>
                  </tr>
                </table>
              </div>
        </div>
      <!-- End -->

      <!-- <div class="mb-2 mt-4">
        <span> <strong>Perquisites (₹)</strong></span>
        <span class="text-right-side"> <strong>₹ 1,20,000</strong></span>
      </div> -->

      <!-- Table -->
        <!-- <div class="datatable-outer-container">
            <div class="datatable-main">
                <table class="datatable">
                  <thead>
                    <tr class="header-row">
                      <th>Particulars</th>
                      <th>Apr'19</th>
                      <th>May'19</th>
                      <th>Jun'19</th>
                      <th>Jul'19</th>
                      <th>Aug'19</th>
                      <th>Sep'19</th>
                      <th>Oct'19</th>
                      <th>Nov'19</th>
                      <th>Dec'19</th>
                      <th>Jan'19</th>
                      <th>Feb'19</th>
                      <th>Mar'19</th>
                    </tr>
                  </thead>
                </table>
              </div>
        </div> -->
      <!-- End -->

      <div class="mb-2 mt-4">
        <span> <strong>Deductions (₹)</strong></span>
        <span class="text-right-side"> <strong>₹ {{ deductionTotal }}</strong></span>
      </div>

      <!-- Table -->
        <div class="datatable-outer-container">
            <div class="datatable-main">
                <table class="datatable">
                  <thead>
                    <tr class="header-row">
                      <th v-for="(column, index) in deductionColumnsList" :key="index" class="table-head"> 
                        {{column}} 
                      </th>
                    </tr>
                  </thead>
                  <tr class="record-row" v-for="(data, index) in deductionList" :key="index">
                    <td class="row-item" v-for="(column, index2) in deductionColumnsList" :key="index2">
                      {{ data[column] ? data[column] : 0 }}
                    </td>
                  </tr>
                </table>
              </div>
        </div>
      <!-- End -->

      <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Back" type="secondary" @click="goBack"/>
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  name: "salaryPerks",
  props: {
    salaryPerk:{
      type:Object
    },
    itSheet:{
      type:Array
    }
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      salaryPerkList:[],
      tdsBreakupList:[],
      columnsList:["Particulars"],
      dataList: [],
      deductionColumnsList: ["Particulars"],
      deductionList: [],
      deductionTotal: 0,
      salaryTotal: 0,
      month: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"]
    };
  }, 
  mounted() {
    this.showSuccessMsg = false;
    this.load();
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.showSuccessMsg = false;
  },

  methods: {
    load(){
      this.salaryPerkList = this.salaryPerk;
      //console.log("salaryPerk Data", this.salaryPerkList);

      const data = Object.keys(this.salaryPerkList.earnings).sort();
      const data2 = Object.keys(this.salaryPerkList.deductions).sort();

      // Earning section
      this.salaryPerkList.earnings.Basic.forEach(element => {        
        let key = Object.keys(element);
        this.columnsList.push(key[0]);
      });

      const months = this.month;
      data.forEach(element => {
        let obj = { Particulars: element }
        const dt = Object.keys(this.salaryPerkList.earnings[element]);
        const keysMonth = dt.sort(function(a, b){
          return months.indexOf(a) - months.indexOf(b);
        });
        //console.log("Sort month:", keysMonth)
        this.salaryPerkList.earnings[element].forEach(ele => {
          let key = Object.keys(ele)[0];
          Object.assign(obj, { [key]: ele[key] })
          this.salaryTotal = this.salaryTotal + ele[key] || 0;
        });
        this.dataList.push(obj);
        obj = undefined;
      });

      // Deduction section
      this.salaryPerkList.deductions[data2[0]].forEach(element => {        
        let key = Object.keys(element);
        this.deductionColumnsList.push(key[0]);
      });

      data2.forEach(element => {
        let obj = { Particulars: element }
        this.salaryPerkList.deductions[element].forEach(ele => {
          let key = Object.keys(ele)[0];
          Object.assign(obj, { [key]: ele[key] })
          this.deductionTotal = this.deductionTotal + ele[key] || 0;
        });
        this.deductionList.push(obj);
        obj = undefined;
      });

      this.tdsBreakupList = this.itSheet;
    },
    
    // Add here code for cancel button to hide popup By Bhushan 
    goBack() {
      this.$emit('back');
    }
  },
};
</script>

<style lang="scss" scoped>

// .business {
//   width: 100%;
//   height: 100%;
// }

// .business .top-bar {
//   height: auto;
//   padding: 20px;
//   background-color: #34c0be;
//   display: flex;
// }

.text-right-side {
  float: right;
}

.section-table {
  padding: 24px 0px;
}

.datatable-outer-container {
  width: 100%;
}
        
.datatable-outer-container table.datatable {
            width: 100%;
            border-collapse: collapse;
            margin: 0 auto;
            font-family: Montserrat;
            margin-bottom: 4px;
}
        
        .datatable-outer-container table.datatable .header-row {
            background-color: white;
            height: 54px;
        }
        
        .datatable-outer-container table.datatable .header-row th {
            background-color: #f0f1f5;
            border-bottom: 1px solid #34c0be;
            padding: 6px 20px;
        }
        
        .datatable-outer-container table.datatable .header-row th .tl-checkbox {
            text-align: center;
        }
        
        .datatable-outer-container table.datatable .inactiveCols {
            opacity: 0.03;
            background-color: #a2a1a1;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader {
            background-color: #ffffff;
            -webkit-box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
            box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th {
            padding: 0 8px;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th span {
            border-right: 1px solid #ececec;
            padding: 0px 18px 0px 15px;
            display: inline-block;
            vertical-align: middle;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th span:first-child {
            padding: 10px 10px 7px 10px;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type {
            text-align: right;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span {
            border-right: none;
            font-weight: 400;
            font-style: italic;
            position: relative;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span i {
            position: absolute;
            right: 10px;
            top: 2px;
        }
        
        .datatable-outer-container table.datatable .record-row {
            height: 60px;
            border-bottom: none;
        }
        
        .datatable-outer-container table.datatable .record-row:nth-child(odd) {
            background-color: #fff;
        }
        
        .datatable-outer-container table.datatable .record-row.selectedRecord {
            background-color: #E9F9F8;
            opacity: 0.9;
        }
        
        .datatable-outer-container table.datatable .record-row td {
            padding: 6px 8px;
            color: #646464;
            font-weight: 500;
        }
        
        .datatable-outer-container table.datatable .record-row td .tl-checkbox {
            text-align: center;
        }
        
        .datatable-outer-container table.datatable .record-row .actions {
            width: 10%;
            padding: 10px;
        }
        
        .datatable-outer-container table.datatable .record-row .row-item {
            padding: 6px 20px;
        }
        
        .datatable-outer-container table.datatable .record-row .row-item p {
            width: 100%;
            margin-bottom: 0px;
        }
        
        .datatable-outer-container table.datatable .record-row .action-img {
            display: inline-block;
            cursor: pointer;
            opacity: 0;
        }
        
        .datatable-outer-container table.datatable .record-row:hover .action-img {
            opacity: 1;
        }

.inputbox{
   width: 149px;
  height: 35px;
  // width: 30%;
  padding: 4px;
  border: 1px solid #c6c9c8;
  border-radius: 4px;
  &:focus {
        outline: none;
        border: 2px solid #37c6c0;
    }
}

.table-head {
  text-transform: capitalize;
}
</style>
